import { getConfiguration } from './utils/configuration';
import { isDevelopmentEnviroment } from './utils';
export function loadTurnstile(){
	//se il contogioco l'ha già caricato, inutile riscaricare
	if(!window.turnstile){
		const script = document.createElement('script');
	    script.setAttribute('src', 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit');
	    script.setAttribute('async', 'true');
	    script.setAttribute('defer', 'true');
	    document.head.appendChild(script);	
	}
}

function removeWidget(){
	try{
		if(window.xsportTurnstileLastWidgetId){
			window.turnstile.remove(window.xsportTurnstileLastWidgetId);
			window.xsportTurnstileLastWidgetId = null;		
		}
		else{
			window.turnstile.remove();
		}
	}
	catch(e){}
}
const alwaysPass = '1x00000000000000000000AA'; // è sempre umano su frontend, ovviamente ti blocca backend
const alwaysBlocks = '3x00000000000000000000FF';
export function humanPurchaseTokenCheckpoint(execCondition, successCallback){
	const conf = getConfiguration();
	if(execCondition && conf.turn?.en && window.turnstile){	
		try{
			removeWidget();
			window.xsportTurnstileLastWidgetId = window.turnstile.render("#turnstile-container", {
		  		"sitekey":  isDevelopmentEnviroment? alwaysBlocks : conf.turn.sk, 
		  		"callback": function (token) {
		    		console.log("Success:", token);
		    		successCallback(token);
		    		removeWidget();
		  		},
		  		"error-callback" : function() {
					successCallback(""); // faccio prendere l'errore dal backend
		  		},
		  		'size' : 'compact',
		  		'appearance' : 'interaction-only'
	  		});
		}
		catch(e){
			console.log(e);
			successCallback("");
		}

	}
	else {
		// se la challenge non e' attiva o se turnstile è null, chiamo direttamente la callback con stringa vuota
		successCallback("");
	}


}